import { REMOVE_PROMO_CODE_ERROR, REMOVE_PROMO_CODE_REQUEST, REMOVE_PROMO_CODE_SUCCESS } from '../types';
import { getAllCartPromotionsForDisplay } from '../../../utils/promotions';
import { getOrLoadCart } from './get-or-load-cart';
import { useHelper } from '../helpers';
export const removePromoCodeRequest = promoCode => {
  return {
    type: REMOVE_PROMO_CODE_REQUEST,
    promoCode
  };
};
export const removePromoCodeSuccess = (cart, promoCode, promoAmount) => {
  return {
    type: REMOVE_PROMO_CODE_SUCCESS,
    data: cart,
    promoCode,
    promoAmount
  };
};
export const removePromoCodeError = error => {
  return {
    type: REMOVE_PROMO_CODE_ERROR,
    error: true,
    payload: error
  };
};
export const removePromoCode = options => {
  return async (dispatch, getState, _ref) => {
    let {
      chord
    } = _ref;
    const {
      promoCode
    } = options;
    const {
      withCart
    } = useHelper(dispatch, getState);
    try {
      dispatch(removePromoCodeRequest(promoCode));
      const {
        data: cart
      } = await getOrLoadCart(dispatch, getState);
      // we only support one promotion per order for now
      const promotions = getAllCartPromotionsForDisplay(cart);
      const promoAmount = promotions ? promotions[0]?.amount : 0;
      await withCart(chord.oms.removeCouponCode)(null, promoCode);
      const updatedCart = await withCart(chord.oms.getOrder)();
      dispatch(removePromoCodeSuccess(updatedCart, promoCode, promoAmount));
      return updatedCart;
    } catch (error) {
      dispatch(removePromoCodeError(error));
      throw error;
    }
  };
};